import { Box, Button, Grid, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ArrowBackOutlined } from '@material-ui/icons';
import React from 'react';

const Footer = ({
  hidden,
  step,
  handleBack,
  handleNext,
  handleCheck,
  shownext,
  finished,
  showerror,
  daten,
  handleFinished,
}) => {
  const handleChange = () => {
    handleNext(daten);
  };
  const handleFinishedButton = () => {
    handleFinished();
  };
  const handleCheckButton = () => {
    handleCheck();
  };

  let renderObjekt;
  if (step === 1) {
    renderObjekt = (
      <div className="flex  min-h-50px flex-wrap bg-grey-1 justify-center items-center">
        <div className="flex">
          <div className="flex ml-4 items-center">
            <FontAwesomeIcon icon={faCheck} color="#1895FF" />
          </div>
          <div className="ml-1 text-xs md:text-base">Hochwertige Analyse</div>
        </div>
        <div className="flex ml-4 items-center">
          <div>
            <FontAwesomeIcon icon={faCheck} color="#1895FF" />
          </div>
          <div className="ml-1 text-xs md:text-base">Aktuelle Marktpreise</div>
        </div>
        <div className="flex ml-4 items-center">
          <div>
            <FontAwesomeIcon icon={faCheck} color="#1895FF" />
          </div>
          <div className="ml-1 text-xs md:text-base">
            100% kostenlos & unverbindlich
          </div>
        </div>
      </div>
    );
  } else {
    renderObjekt = (
      <div className="flex h-50px bg-grey-2 justify-between">
        <Button
          variant="contained"
          size="large"
          id="backbuttonx"
          disabled={step === 1}
          onClick={handleBack}
        >
          <ArrowBackOutlined />
        </Button>
        {shownext && showerror == undefined && (
          <Button
            variant="contained"
            size="large"
            onClick={handleChange}
            id="weiterbuttonx"
          >
            {'Weiter'}
          </Button>
        )}
        {showerror != undefined && (
          <Button
            variant="contained"
            size="large"
            onClick={handleCheckButton}
            id="weiterbuttonx"
          >
            {'Weiter'}
          </Button>
        )}
        {finished && (
          <Button
            variant="contained"
            id="deleteinputs"
            size="large"
            onClick={handleFinishedButton}
          >
            {'Eingaben Zurücksetzen'}
          </Button>
        )}
      </div>
    );
  }

  return renderObjekt;
};

export default Footer;
